import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';

export type TagModel = {
  id: number;
  name: string;
  color: string;
};

export default function TagsIndex() {
  const [isLoading, setIsLoading] = useState(true);
  const [tags, setTags] = useState([] as TagModel[]);

  const {
    user: { organization },
  } = useAuth();

  async function getTags() {
    if (organization) {
      setIsLoading(true);
      const response = await api.get(`organizations/${organization.id}/tags`);
      setTags(
        response.data.data.map((tag: any) => ({
          ...tag,
          color: `#${tag.color}`,
        }))
      );
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getTags();
  }, [organization]);

  return (
    <List isLoading={isLoading} title='Etiquetas' newItemUrl='new'>
      <table className='table table-hover'>
        <thead>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Nome</th>
          </tr>
        </thead>
        <tbody>
          {tags.map((i) => {
            return (
              <tr key={i.id}>
                <td>{i.id}</td>
                <td>
                  <Link to={`/tags/${i.id}/edit`} style={{ color: i.color }}>
                    {i.name}
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </List>
  );
}
